var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200.794,
    height: 551.722,
    viewBox: "0 0 1200.794 551.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_path",
    transform: "translate(-26.569 -30.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "magnet-svgrepo-com",
    transform: "translate(424.473 138.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3971",
    "data-name": "\\uD328\\uC2A4 3971",
    d: "M173.077,0h-3.4C76.957,0,1.527,75.43,1.527,168.146v70.445a10.518,10.518,0,0,0,11.055,10.63h44.74c-6.614,6.8,8.023-3.91,10.254-8.462l15.554-72.614A86.64,86.64,0,0,1,169.672,81.6h3.4a86.64,86.64,0,0,1,86.541,86.542v70.636a10.281,10.281,0,0,0,10.75,10.439h59.214c8.541,0,11.641-5.959,11.641-9.964V168.146C341.222,75.43,265.793,0,173.077,0Z",
    transform: "translate(47 -108)",
    fill: "#edecec"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3972",
    "data-name": "\\uD328\\uC2A4 3972",
    d: "M1.094.047,82.7.113,81.543,108.35,0,108.371Z",
    transform: "translate(730 256)",
    fill: "#edecec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "magnet-svgrepo-com-2",
    "data-name": "magnet-svgrepo-com",
    transform: "translate(1118.222 393.348) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3971-2",
    "data-name": "\\uD328\\uC2A4 3971",
    d: "M173.077,0h-3.4C76.957,0,1.527,75.43,1.527,168.146c0,0,.164,49.928,0,70.445S.862,250.359,12.55,249.875s50.855,22.179,54.776,14.338,9.8-22.4,13.721-45.084,2.084-50.984,2.084-50.984A86.64,86.64,0,0,1,169.672,81.6h3.4a86.64,86.64,0,0,1,86.541,86.542v70.636a10.281,10.281,0,0,0,10.75,10.439h59.214c8.541,0,11.641-5.959,11.641-9.964V168.146C341.222,75.43,265.793,0,173.077,0Z",
    transform: "translate(47 -128)",
    fill: "#edecec"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uBE7C\\uAE30_1",
    "data-name": "\\uBE7C\\uAE30 1",
    d: "M-3877.688-2522.259h-71.11c-4.005,0-9.965-3.1-9.965-11.641v-59.214a10.281,10.281,0,0,1,10.438-10.75h70.636c45.115,0,76.624-35.223,76.624-85.656V-2692h81.638v2.482a190.476,190.476,0,0,1-3,33.807,178.5,178.5,0,0,1-8.693,31.442,168.2,168.2,0,0,1-13.938,28.417,159.431,159.431,0,0,1-18.734,24.732,152.911,152.911,0,0,1-23.08,20.386,150.207,150.207,0,0,1-26.976,15.379A157.526,157.526,0,0,1-3877.688-2522.259Z",
    transform: "translate(4274 2886.63)",
    fill: "#edecec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uBE7C\\uAE30_3",
    "data-name": "\\uBE7C\\uAE30 3",
    d: "M-3877.688-2522.259h-71.11c-4.005,0-9.965-3.1-9.965-11.641v-59.214a10.281,10.281,0,0,1,10.438-10.75h70.636c45.115,0,76.624-35.223,76.624-85.656V-2692h81.638v2.482a190.476,190.476,0,0,1-3,33.807,178.5,178.5,0,0,1-8.693,31.442,168.2,168.2,0,0,1-13.938,28.417,159.431,159.431,0,0,1-18.734,24.732,152.911,152.911,0,0,1-23.08,20.386,150.207,150.207,0,0,1-26.976,15.379A157.526,157.526,0,0,1-3877.688-2522.259Z",
    transform: "translate(-3537.857 -2240.557) rotate(-180)",
    fill: "#edecec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uBE7C\\uAE30_4",
    "data-name": "\\uBE7C\\uAE30 4",
    d: "M-3877.277-2522.259h-71.471c-4.025,0-10.014-3.1-10.014-11.641v-59.214a10.309,10.309,0,0,1,10.492-10.75h70.993c45.344,0,77.012-35.223,77.012-85.656V-2692h82.052v2.482a189.551,189.551,0,0,1-3.013,33.807,177.766,177.766,0,0,1-8.737,31.442,167.814,167.814,0,0,1-14.009,28.417,159.482,159.482,0,0,1-18.829,24.732,153.44,153.44,0,0,1-23.2,20.386,151.186,151.186,0,0,1-27.113,15.379A159.013,159.013,0,0,1-3877.277-2522.259Z",
    transform: "translate(3985.332 3104.259)",
    fill: "#edecec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uBE7C\\uAE30_2",
    "data-name": "\\uBE7C\\uAE30 2",
    d: "M-3877.688-2522.259h-71.11c-4.005,0-9.965-3.1-9.965-11.641v-59.214a10.281,10.281,0,0,1,10.438-10.75h70.636c45.115,0,76.624-35.223,76.624-85.656V-2692h81.638v2.482a190.476,190.476,0,0,1-3,33.807,178.5,178.5,0,0,1-8.693,31.442,168.2,168.2,0,0,1-13.938,28.417,159.431,159.431,0,0,1-18.734,24.732,152.911,152.911,0,0,1-23.08,20.386,150.207,150.207,0,0,1-26.976,15.379A157.526,157.526,0,0,1-3877.688-2522.259Z",
    transform: "translate(-2731.399 -2366.338) rotate(180)",
    fill: "#edecec"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPath);
export default __webpack_public_path__ + "static/media/ic_path.5e846c3e8159bbab677053cdbca9b203.svg";
export { ForwardRef as ReactComponent };